import { PaymentMethods } from '../../models';
import { PaymentMethodsActions, PaymentMethodsActionTypes } from './payment-methods.actions';

export interface State {
  paymentMethods: PaymentMethods[];
  loading: boolean;
  error: any;
}

export const initialState: State = {
  paymentMethods: [],
  loading: false,
  error: null,
};

export function reducer(state = initialState, action: PaymentMethodsActions): State {
  switch (action.type) {
    case PaymentMethodsActionTypes.READ_PAYMENT_METHODS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PaymentMethodsActionTypes.READ_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        paymentMethods: action.payload,
        loading: false,
      };

    case PaymentMethodsActionTypes.READ_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
